/* eslint-disable @typescript-eslint/no-unused-vars */
import { StoreContext } from "store/store-context";
import { Document, DocumentAnswer, DocumentQuestion, DocumentSection } from "store/types";
import { FilesQueryBy } from "store/types";
import { useContextSelector } from "use-context-selector";
import querySelector from "utils/query-selector";

// Documents
export const useAllDocumentsSelect = (): Document[] => useContextSelector(StoreContext, (state) => state.documents);

export const useDocumentsSelect = (where: FilesQueryBy): Document[] =>
  useContextSelector(StoreContext, (state) => querySelector(state.documents, where));

export const useDocumentSelect = <withContent extends boolean = true>(id: number): Document<withContent> | undefined =>
  useContextSelector(StoreContext, (state) => state.documents.find((doc) => doc.id === id) as Document<withContent>);

// export const useAllDocumentSectionsSelect = (documentId: number): DocumentSection[] => {
//   return (
//     useContextSelector(StoreContext, (state) => state.documents.find((doc) => doc.id === documentId)?.sections) || []
//   );
// };

// export const useDocumentSectionSelect = ({
//   documentId,
//   sectionId
// }: {
//   documentId?: number;
//   sectionId?: number;
// }): DocumentSection | undefined => {
//   if (!documentId || !sectionId) return;
//   return useContextSelector(StoreContext, (state) =>
//     state.documents.find((doc) => doc.id === documentId)?.sections?.find((sec) => sec.id === sectionId)
//   );
// };

// export const useDocumentQuestionsSelect = ({
//   documentId,
//   ...where
// }: Pick<DocumentQuestion, "section_id"> & { documentId: number }): DocumentQuestion[] => {
//   return useContextSelector(StoreContext, (state) => {
//     const document = state.documents.find((doc) => doc.id === documentId);
//     if (!document?.questions?.length) return [];
//     return querySelector(document.questions, where);
//   });
// };

// export const useDocumentAnswersSelect = ({
//   documentId,
//   ...where
// }: { documentId: number } & Partial<Pick<DocumentAnswer, "question_id" | "parent_answer_id">>): DocumentAnswer[] => {
//   return useContextSelector(StoreContext, (state) => {
//     const document = state.documents.find((doc) => doc.id === documentId);
//     if (!document?.answers?.length) return [];
//     return querySelector(document.answers, where);
//   });
// };
